import React, { ReactNode, FC ,useMemo, useEffect,useState } from 'react';
import classNames from 'classnames/bind';
import FallbackableImage from '../../../../refresh/molecules/FallbackableImage';
import Text from '../../../../refresh/atoms/Text';
import { VariantType } from '../../../../refresh/atoms/Text/Text';
// import ProductLabel from '../../../../refresh/molecules/ProductLabel';
import PriceRevealPLP from '../../../../components/common/ListingPage/priceRevealPLP/PriceRevealPLP';
import styles from './index.pcss';
import { redirect } from '../../../../refresh/utils/cartUtils';
import { sendEventGA } from '../../../../refresh/utils/gaEvents';
import { addCustomerType } from '../../../../utils/products';
import {
  getProductItemPDP,
  luxeGtmProductClick,
  segmentEventPush
} from '../../../../modules/ga/GTMdatalayer';
import { connect } from 'react-redux';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';
import { getVariant } from '../../../../refresh/organism/ABFeature/Feature';
import Button from '../../../../refresh/atoms/button';
import Icon from '../../../../refresh/atoms/Icon';
import getWishlistPriceDropData from '../../../../refresh/utils/wishlistPriceDropUtils';
import { signInCheck } from '../../../../components/common/CheckUserStatus';
import luxeList from '../../../../refresh/constants/luxeScreenType';
import properties from '../../../../modules/ajio-util/properties';
import AggregatedRatingTag from '../../../../refresh/atoms/AggregatedRatingTag';
import { Feature, Variant } from '../../../../refresh/organism/ABFeature';
import { getEnableRating, getEnableRatingLabelCart, getPriorityDeliveryConfig, getPriorityDeliveryPhase2Flag, getPriorityDeliverySLPTagsConfig, getRushDeliveryFlag } from '../../../../refresh/selectors/featureFlagsSelector';
import { isCatalogNameInFirebaseStore } from '../../../../utils/common';
import { getStoresForHidingMRP, getStreetFlags } from '../../../../refresh/selectors/featureFlagsSelector';
import { STREET_STORE } from '../../../../constants/constant';
import { catalogIdToStoreName } from '../../../../utils';
import { setLandingPageScrollCookies } from '../../../../utils/banner';
import Constant from '../../../../utils/AjioWalletConstants';
import { deliveryMethod as DELIVERY_METHOD } from '../../../../refresh/constants/ordersData.constants';
import {formatPrice} from '../../../../refresh/utils/priceUtils';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';
const ajioUrl = properties.getProperty('parentUrl');
const fleekURL = properties.getProperty('fleekURL');
const luxeUrl = properties.getProperty('luxeURL');
const streetURL = properties.getProperty('streetURL');
const imageBaseUrl = properties.getProperty("imageBaseUrl") ;

const textVariants: VariantType[] = ['T2', 'T2'];
// TODO: update `Product` after understanding data
type Product = {
  id: string;
  mainImage: string;
  imageHeight: number;
  imageWidth: number;
  description: string;
  brand: string;
  model: string;
  currentPrice: number;
  actualPrice: number;
  discount: number;
  descriptionPageURL: string;
};
type Size = 'xl' | 'lg' | 'md' | 'sm';
interface ProductCardProps {
  size?: Size;
  product: Product;
  newTabOpener?: boolean;
  emphasizeDiscount?: boolean;
  renderAddOns?: (product: Product) => ReactNode;
  containerClass?: string;
  disabled?: boolean;
  showDiscount?: boolean;
  isPriceReveal?: boolean;
  isPriceRevealDuringSale?: boolean;
  luxe?: boolean | undefined;
  pageType?: string | undefined;
  eventPush?:(A: Record<string, string>) => void;
  eventPushObj?:object | undefined;
  index:number;
  pageList?:string;
  currentStore?:string;
  isWishlisted?:boolean | undefined;
  addToWishlistApi?:(code: any, productColor: any) => void;
  similarProductsVariant:number;
  recentlyViewed: Array<object>;
  isRecentView? :boolean;
  enableRating? : boolean;
  enableRatingLabelCart : boolean;
  widgetTitle?:string;
  storesForHidingMRP:  Array<object>;
  showDynamicWidgetMoreLink?: boolean;
  ctaText?: string,
  isDynamicProductList?: boolean,
  viewShowMoreProducts: () => void;
  dynamicProductWidgetRedirection: (url : string) => void;
  heading:string | undefined;
  rowNumber:Number;
  banners:any;
  curatedId?: string;
  isSimilarStyle: boolean | undefined;
  isSimilarStyleDialog: boolean | undefined;
  fleekPlp: boolean;
  isFromAjiogramLandingPage?: boolean;
  isPlpOnLandingWidget?: boolean;
  plpOnLandingProductConfig?: object;
  priorityDeliveryConfig?: object;
  priorityDeliveryTagsBucket?: object;
  ajiogramInterventionsConfig?: object;
  isPlpOnLandingEnabled: boolean;
  plpOnLandingHeading?: string;
}

const ProductCard: FC<ProductCardProps> = (props: ProductCardProps) => {
  const {
    pageType = '',
    product,
    size,
    renderAddOns,
    newTabOpener,
    containerClass,
    emphasizeDiscount,
    disabled,
    showDiscount,
    isPriceReveal,
    isPriceRevealDuringSale,
    luxe,eventPush,eventPushObj,
    index,
    pageList,
    isWishlistHalfcard,
    currentStore,
    productWidgetCard = false,
    addToWishlistApi,
    similarProductsVariant,
    recentlyViewed,
    isRecentView,
    enableRatingLabelCart,
    enableRating = false,
    widgetTitle,
    storesForHidingMRP,
    isStreetStore,
    showDynamicWidgetMoreLink,
    ctaText,
    isDynamicProductList,
    viewShowMoreProducts,
    dynamicProductWidgetRedirection,
    banners,
    curatedId,
    heading,
    rowNumber,
    isSimilarStyle = false,
    isSimilarStyleDialog = false,
    fleekPlp = false,
    isFromAjiogramLandingPage = false,
    enableRushDelivery,
    enablePriorityDeliveryPhase2,
    priorityDeliverySLPTagsConfig,
    isPlpOnLandingWidget = false,
    plpOnLandingProductConfig = {},
    priorityDeliveryConfig = {},
    priorityDeliveryTagsBucket = {},
    ajiogramInterventionsConfig = {},
    isPlpOnLandingEnabled = false,
    plpOnLandingHeading = ''
  } = props;
  const { plp : {screenType ='', screenName=''}, similarTo : {widgetName = ''} } = luxeList;
  const {
    showProductRating = false,
    showProductTag = false,
    showWishlist = false,    
    showSellingFastTag = false,
    showPriorityDeliveryTag = false,
    showAjiogramTag = false
  } = plpOnLandingProductConfig;
  const {
    plpConfig: {
      tagContent: { logo = '', text = '', backgroundColor = '', textColor = '' } = {},
      enableIntervention = false
    } = {}
  } = ajiogramInterventionsConfig;

  const {
    id,
    mainImage,
    imageHeight,
    imageWidth,
    description,
    brand,
    model,
    currentPrice,
    catalogName,
    actualPrice,
    discount,
    descriptionPageURL,
    offerPrice,
    priceValue,
    code,
    brickName,
    productTag,
    productTagEngineValue,
    deliverySlaTag,
    productSellingFastTag,
    productPriceLabel,
    isExclusive,
    productColor,
    productCategory,
    productSize,
    averageRating,
    numUserRatings,
    deliveryMethod='',
    slaDeliveryTag=''
  } = product;
  let storeForRedirect = 0;
  const { PLP_BUCKET = {} } = priorityDeliverySLPTagsConfig ? priorityDeliverySLPTagsConfig : {};

  if(isRecentView && recentlyViewed?.length > 0 ) {
     const recentlyViewedItemIndex = recentlyViewed?.findIndex(el => el.id == productColor);
     storeForRedirect = recentlyViewedItemIndex > -1 ? recentlyViewed[recentlyViewedItemIndex].store : 0;
  }
  const session_id =
    typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('sessionId') : '';
  const enablePlpIntervention =
    enableIntervention &&
    String(currentStore).toLowerCase() === 'ajio' &&
    String(catalogName).toLowerCase() === 'ajiogram';
 
  const discountSplit = discount?.split(" ");
  const prodDiscount = discountSplit?.length > 0 ? discountSplit[0] : '';
  const { priceReveal, value } = offerPrice || {};
  const cx = classNames.bind(styles);
  const isFleekPDPPage =  pageType === 'pdp-msite' ? ( isSimilarStyle ? isSimilarStyleDialog ? 'fleek-pdp-similar-style-dialog-container' : fleekPlp ? 'fleek-plp-similar-style-container' : 'fleek-pdp-similar-style-container' : 'fleek-pdp-container' ) : '';
  const containerCls = cx(
    isFleekPDPPage,
    showDynamicWidgetMoreLink ? 'dynamic-widget' : '',
    isPlpOnLandingWidget ? 'plp-on-landing-prdt' : '',
    showDynamicWidgetMoreLink && luxe ? 'luxe-article-container' : '',
    pageType === 'pdp-msite' && luxe
      ? 'luxe-container'
      : pageType === 'pdp-msite'
      ? 'pdp-container'
      : 'container',
    {
      productWidgetCard: productWidgetCard && luxe
    },
    {
      [`${
        luxe && pageType !== 'pdp-msite'
          ? 'luxe'
          : luxe && pageType === 'pdp-msite'
          ? 'pdpluxe'
          : pageType === 'pdp-msite'
          ? 'pdp'
          : ''
      }container-${size}`]: true,
      [containerClass]: !!containerClass
    }
  );
  const imgCls = cx({
    [`${pageType === 'pdp-msite' && luxe ? 'pdpluxe' : pageType === 'pdp-msite'? 'pdp' : luxe ? 'luxe' : ''}img-${size}`]: true,
    'img-disabled': !!disabled,
    'plp_landing-page__img': isPlpOnLandingEnabled
  },{
      productWidgetCardImage : productWidgetCard && luxe
    });
  const priceCls = cx(isSimilarStyleDialog ? 'fleekSimilarStylesPdpPrice' : 'fleekPdpPrice', luxe ? (pageType !== 'pdp-msite' ? 'luxePrice' : 'pdpluxeprice') : pageType === 'pdp-msite' ? 'pdpPrice' :'price', {
    [`price-${size}`]: true
  });

  const repositionWishlistButtons = () => {
  const containers = document.querySelectorAll<HTMLElement>("#plp_wishlist");

  containers.forEach((container) => {
    const parent = container.closest("#home_plp"); // main card container
    const img = parent?.querySelector<HTMLImageElement>("a > img");

    if (!img) return;

    const height = img.offsetHeight;
    if (!height) return; // skip if image not loaded yet

    const topPosition = luxe ? `${height - 20}px`: `${height - 40}px`; // adjust 40px = icon size

    Object.assign(container.style, {
      position: "absolute",
      top: topPosition,
      right: "10px", // tweak for spacing
      zIndex: "5",
    });

    // ensure parent is positioning context
    if (parent) {
      (parent as HTMLElement).style.position = "relative";
    }
  });
};

  useEffect(() => {
    repositionWishlistButtons();

    window.addEventListener("resize", repositionWishlistButtons);

    // Clean up the observer when the component unmounts
    return () => {
      window.removeEventListener("resize", repositionWishlistButtons);
    };
  }, []);

   useEffect(() => {
    repositionWishlistButtons();
  }, [props.product]);

  const checkIsWishlisted = (productCode) => {
    const username = signInCheck(true);
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if(!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if(!userWishlistData) return false;
    const { codes = [] } = userWishlistData;
    if(codes.length === 0) return false;
    return codes.includes(productCode);
  }
  const wishlistIconCommonStyles = {
    fontWeight: 'bold',
    zIndex: 1,
    color: checkIsWishlisted(productColor) && !luxe ? '#f97676' : '#202020',
  };

  const getDiscountFontSize: (cardSize: Size) => string = cardSize => {
    let fontSize;
    switch (cardSize) {
      case 'sm':
        fontSize = 'T1';
        break;
      case 'md':
        fontSize = 'T2';
        break;
      default:
        fontSize = 'T2';
        break;
    }
    return fontSize;
  };
  const redirectFn = redirect(isRecentView ? (storeForRedirect == 2 ?  streetURL : (storeForRedirect == 1 ? luxeUrl : ajioUrl)) +  descriptionPageURL : descriptionPageURL) ;
  const product_tag = isExclusive ? 'EXCLUSIVE' : productTag
  const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName)
  return (
    <article key={id} className={containerCls}id={widgetTitle?`product_${widgetTitle}_${index}`:`product_${index}` } tabIndex={0} role="button" aria-label={`View product: ${brand}, Price: ${currentPrice}`}>
      {showDynamicWidgetMoreLink ?
        <div className={cx('view-more-main-container', luxe ? 'view-more-main-container-luxe' : '')} onClick={() => viewShowMoreProducts()}>
        <div className={cx('show-view-more', !luxe ? 'rounded-corner' : 'luxe-container')} style={{ width: luxe ? "auto" : "143px", height: luxe ? "170px" : "18rem" }}>
          <div className={cx('view-more-container')}>
            <p className={cx('ctaText')}>{ctaText}</p>
            <img alt="Right arrow" src={`${imageBaseUrl}/static/img/show-view-more-arrow.svg`}/>
          </div>
        </div>
        </div>
      : 
      <div id="home_plp" data-code={code}>

      <a
        className={cx('pdp-link',true ? 'pos-relative' : '')}
        href={isDynamicProductList ? 'javascript:void(0);' : addCustomerType(isRecentView ? (storeForRedirect == 2 ?  streetURL : (storeForRedirect == 1 ? luxeUrl : fleekURL)) +  descriptionPageURL : descriptionPageURL)}
        onClick={() => {
          eventPush && eventPush({ 
            eventName: productWidgetCard ? 'view_item_list': 'widget_clicks',
            event_category:'widget interactions',
            event_action: 'widget clicks',
            ...(averageRating && numUserRatings && { dimension46: `${averageRating}|${numUserRatings}` }),
            ...eventPushObj 
          });

          let listValue = pageType? similarProductsVariant && pageType =='plp' ? screenName + ' - ' + widgetName : pageList : 'bag screen';
            if (isDynamicProductList) {
              listValue =
                banners.widgetLevel.toLowerCase() === 'user'
                  ? `user_level_${banners?.feedLogic}_${heading}_${rowNumber}`
                  : `dynamic_${banners?.feedLogic}_${heading}_${rowNumber}`;
            }
          !isPlpOnLandingWidget && luxeGtmProductClick({
            name:description,
            id:(code.length > 9 ? code.substring(0,9) : code),
            price:priceValue,
            brand,
            position: id,
            category:productCategory,
            product_size:productSize,
            product_color:productColor?productColor.split('_')[1]:"",
            product_trade_discount:discount,
            product_brick:brickName,
            product_tag:getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : product_tag,
            list:listValue,
            store_type:currentStore,
            pageType: pageType ? similarProductsVariant && pageType =='plp' ? screenName :'pdp screen' : 'bag screen',
            pageName: pageType ? similarProductsVariant && pageType =='plp' ? '' : 'pdp screen' : 'bag screen',
            sourceStore: catalogIdToStoreName(catalogName),
            containsLuxe: true,
            productTagEngineValue: pageType === 'pdp' && getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : '',
            productPriceLabel: pageType === 'pdp' && getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
            catalog: catalogName,
            skuId: product?.firstSizeVariantCode || ''
          })
          if (isPlpOnLandingWidget) {
            luxeGtmProductClick({
              name: description,
              id: (code.length > 9 ? code.substring(0,9) : code),
              price: priceValue,
              brand,
              position: id,
              category: productCategory,
              product_size: productSize,
              product_color: productColor?productColor.split('_')[1]:"",
              product_trade_discount: discount,
              product_brick: brickName,
              product_tag: product_tag || productTagEngineValue,
              list: plpOnLandingHeading
                ? `endless_plp_${plpOnLandingHeading}`
                : 'endless_plp_widget_landing',
              impression_source: 'endless_plp_widget_landing',
              impression_type: 'Widget',
              store_type: currentStore,
              pageType: 'home landing screen',
              pageName: 'home landing screen',
              sourceStore: catalogIdToStoreName(catalogName),
              containsLuxe: luxe,
              productTagEngineValue: productTagEngineValue || product_tag,
              productPriceLabel: productPriceLabel,
              catalog: catalogName,
              skuId: product?.firstSizeVariantCode || ''
            })
            segmentEventPush({
              event: 'Widget Clicked',
              page_name: 'home landing screen',
              page_type: 'home landing screen',
              screen_name: 'home landing screen',
              store_type: currentStore,
              session_id,
              widget_id: curatedId,
              widget_name: 'endless_plp_widget_landing',
              widget_position: banners?.position,
              widget_type: 'product widget'
            });
          }
          setLandingPageScrollCookies('MSITE');
          if(isDynamicProductList) {
            const url = addCustomerType(isRecentView ? (storeForRedirect == 2 ?  streetURL : (storeForRedirect == 1 ? luxeUrl : ajioUrl)) +  descriptionPageURL : descriptionPageURL);
            dynamicProductWidgetRedirection(url);
          } else {
            redirectFn();
          }
          sendEventGA({
            eventCategory: 'Page Interaction',
            eventAction: 'link click: pagelinks-1',
            eventLabel: brand
          });
        }}
        target={newTabOpener ? '_blank' : '_self'}
        rel={newTabOpener ? 'noopener noreferrer' : ''}
        role="presentation"
        tabIndex={-1}
        aria-hidden="true"
      >
        <FallbackableImage
          src={mainImage}
          alt={description}
          imageCls={imgCls}
          customErroredImgCls={cx('img-load-errored')}
          isPlpOnLandingWidget
        />
        {isPlpOnLandingWidget && showProductTag && (product_tag || productTagEngineValue) && (
          <div
            className={cx('product-tag', (product_tag || productTagEngineValue) === 'NEW' && 'new-tag')}
            aria-label={product_tag || productTagEngineValue}
          >
            {product_tag || productTagEngineValue}
          </div>
        )}
        {isPlpOnLandingWidget && showAjiogramTag && enablePlpIntervention && (
          <div className={cx('intervention-tag')} style={{ backgroundColor: backgroundColor }}>
            {' '}
            <img src={logo} alt="ajiogram tag" />
            <div style={{ color: textColor }} className={cx('text')}>
              {text}
            </div>
          </div>
        )}
        <header
          id="brand"
          className={luxe ? (pageType !== 'pdp-msite' ? cx('brand-title') : cx('brand-header')) : cx('ajio-header')}
        >
          <div className={cx('brand-name-heading')}>
          <Text
            variant="T2"
            color={luxe ? 'Light_Black' : 'White'}
            weight="bold"
            textTransform={luxe ? 'is-uppercase' : 'none'}
            customClass={pageType === 'pdp-msite' && !isFromAjiogramLandingPage ? cx('brand-name') : cx('brand-name-product-widget-fleek')}
          >
            {brand}
          </Text>
          </div>
          {/* <ProductLabel title={brand} description={model} withNoWrap textVariants={textVariants} /> */}
        </header>
          {!(productWidgetCard && isPriceReveal) && (
            <Text
              variant={'T2'}
              color={isFromAjiogramLandingPage ? 'Grey_White' : luxe ? 'Light_Black' : 'Link_Water'}
              textTransform="is-capitalized"
              customClass={cx(
                pageType === 'pdp-msite'
                  ? luxe
                    ? 'pdpluxe-description-title'
                    : 'pdp-description-title'
                  : 'description-title'
              )}
            >
          {description}
        </Text>)}
          {enableRating &&
            averageRating &&
            enableRatingLabelCart &&
            (isPlpOnLandingWidget ? showProductRating : true) && (
            <AggregatedRatingTag
              ratingValue={averageRating}
              totalRatingCount={numUserRatings}
              customClass={
                isSimilarStyle
                  ? 'fleek-similar-styles-rating-label-msite-cart-halfcard'
                  : 'fleek-rating-label-msite-cart-halfcard'
              }
              backGroundColour={averageRating < 3 ? 'red' : 'green'}
              isFleek={true}
              luxe={luxe}
              isFromPDP={pageType === 'pdp-msite'}
            />
        )}
        <div id="price_detail" className={priceCls}>
          <Text
            variant={luxe ? 'T1' : isSimilarStyle ? (isSimilarStyleDialog ? 'T1' : 'T2') : 'T2'}
            color={luxe ? 'Light_Black' : 'White'}
            weight={luxe ? 'regular' : 'bold'}
          >
            {currentPrice}
          </Text>
          {!!actualPrice &&  actualPrice!==currentPrice && hideMRP && (
            <Text
              variant={luxe ? 'T1' : isSimilarStyle ? (isSimilarStyleDialog ? 'T1' : 'T2') : 'T2'}
              color={luxe ? 'Light_Charcoal' : 'Link_Water'}
              weight={luxe ? 'regular' : 'bold'}
              customClass={luxe&&pageType==="pdp-msite"?cx('product-price'):''}
            >
              {actualPrice}
            </Text>
          )}
          {!!discount && showDiscount && actualPrice!==currentPrice && hideMRP && (
            <Text
              variant={luxe ? 'T1' : isSimilarStyle ? (isSimilarStyleDialog ? 'T1' : 'T2') : 'T2'}
              color={emphasizeDiscount ? (luxe ? 'Nero' : isSimilarStyle && !isSimilarStyleDialog ? fleekPlp ? 'Fleek_Green' : 'White' : 'Atlantis') : 'Nero'}
              weight="bold"
            >
              {prodDiscount +" OFF"}
            </Text>
          )} 
        </div>
        {offerPrice && (
            <div className={cx('offer_price','msite')}>
              <img
                src={`${imageBaseUrl}/static/img/percentage.svg`}
                alt="Offer icon"
                className={cx(
                  'offer-icon',
                  isPlpOnLandingEnabled ? 'plp_landing-page__offer_icon' : ''
                )}
              />
              <div>Offer Price : {Constant.AW_RUPEE_SYMBOL}
              {formatPrice(offerPrice?.displayformattedValue)}
              </div>
            </div>
          )}
        {/* {isPriceReveal && ( */}
            {/* <PriceRevealPLP
              isPriceRevealPDP={isPriceRevealDuringSale || (isWishlistHalfcard && isPriceReveal)}
              isPriceReveal={isPriceReveal}
              priceReveal={priceReveal}
              orignalPrice={priceValue || '00'}
              offerValue={value}
              priceRevealClass="pr-pdp"
              pageType = {pageType}
              luxe={luxe}
              isWishlistHalfcard = {isWishlistHalfcard}
              hasLineBreak={luxe?true:false}
            /> */}
          {/* )} */}
        {isPlpOnLandingWidget &&
          showPriorityDeliveryTag &&
          deliverySlaTag &&
          priorityDeliveryTagsBucket[`${deliverySlaTag}`] && (
            <div
              className={
                cx(isFromAjiogramLandingPage ? 'fleek-pd-tag-container' : 'pd-tag-container')
              }
            >
              <img
                className={cx('pd-tag-icon')}
                alt="Priority Delivery Tag Icon"
                src={
                  isFromAjiogramLandingPage
                    ? priorityDeliveryConfig?.PD2_TRUCK_ICON_AJIOGRAM
                    : priorityDeliveryConfig?.PD2_TRUCK_ICON
                }
              />
              <span className={cx(isFromAjiogramLandingPage ? 'fleek-pd-tag-text' : 'pd-tag-text')}>
                {priorityDeliveryTagsBucket[`${deliverySlaTag}`]}
              </span>
            </div>
          )}
        {isPlpOnLandingWidget && showSellingFastTag && productSellingFastTag && (
          <div className={cx('selling-fast-tag-container')}>
            <Text
              variant={luxe ? 'T1' : 'T2'}
              weight="bold"
              color={luxe ? 'Light_Black' : 'Salmon'}
            >
              {productSellingFastTag}
            </Text>
          </div>
        )}
        {renderAddOns && renderAddOns(product)}
      </a>
      
        {((pageType == 'plp' || (isPlpOnLandingWidget && showWishlist)) &&
          similarProductsVariant) &&
          (!luxe || (isPlpOnLandingWidget && showWishlist)) &&
          <div
            id="plp_wishlist"
            className={cx('wishilistContainerScroll', luxe ? 'luxeWishilistContainer' : '')}
          >
            <div className={cx("wishlistBack")}  onClick={e => {  
              e.preventDefault();
              e.stopPropagation();
              segmentEventPush({
                event: 'Product Wishlisted',
                event_category: 'add_to_whishlist',
                event_action: 'added sucessfully',
                products : [ {
                        ...getProductItemPDP(product, index)
                }],          
                screen_name: 'plp screen',                              
              });
              addToWishlistApi(code, productColor)
              }}
              role="button"
              tabIndex={0}
              aria-label={checkIsWishlisted(productColor) ? `Remove from wishlist ${description?.substring(0, 4)}` : `Add to wishlist ${description?.substring(0, 4)}`}
              >
              <Icon
                icon={
                  checkIsWishlisted(productColor) ? 'icon-Wishlist_Active' : 'icon-Wishlist'
                }
                styles={
                  isPlpOnLandingWidget && showWishlist
                    ? {
                        fontSize: '1.8rem',
                        marginTop: '-1px',
                        marginLeft: '1px',
                        ...wishlistIconCommonStyles
                      }
                    : { fontSize: '2.1rem', ...wishlistIconCommonStyles }
                }
                ariaHidden={true}
              />
            </div>
          </div>
        }
      </div>
      }
      {
      (enableRushDelivery || enablePriorityDeliveryPhase2) &&       //RUSH badge and sls showcasing inRecommended products on PDP fleek 
        slaDeliveryTag &&
        PLP_BUCKET[`${slaDeliveryTag}`] &&
        (pageType === 'pdp-msite' || pageType === 'pdp') && (
          <div
            className={cx('priority-delivery-container')}
            style={{display:"flex"}}
          >
            <img
              className={cx("priority-delivery-icon")}
              alt={deliveryMethod === DELIVERY_METHOD.RUSH ? "Rush Icon" : "Priority Delivery Icon"}
              src={
                deliveryMethod === DELIVERY_METHOD.RUSH
                  ? replaceWithJioCDN(priorityDeliveryConfig?.RUSH_ICON)
                  : replaceWithJioCDN(priorityDeliveryConfig?.PD2_TRUCK_ICON)
              }
            />
            <span
              className={cx('priority-delivery-text')}
            >
              {PLP_BUCKET[`${slaDeliveryTag}`]}
            </span>
          </div>
        )}
    </article>
  );
};
ProductCard.defaultProps = {
  size: 'md',
  newTabOpener: false,
  emphasizeDiscount: true,
  showDiscount: true,
  isPriceReveal: false,
  isPriceRevealDuringSale: false
};
const mapStateToProps = (state, ownProps) => {
  const { isThemeEnableMsite } = getStreetFlags(state);

  return {
    currentStore:getCurrentStore(state),
    recentlyViewed : state?.recentlyViewed?.recent || [],
    enableRating : getEnableRating(state.flags,state),
    enableRatingLabelCart : getEnableRatingLabelCart(state) === 'ON',
    storesForHidingMRP : getStoresForHidingMRP(state),
    isStreetStore: isThemeEnableMsite === 'ON' && getCurrentStore(state) === STREET_STORE,
    enableRushDelivery: getRushDeliveryFlag(state),
    enablePriorityDeliveryPhase2: getPriorityDeliveryPhase2Flag(state.flags),
    priorityDeliveryConfig: getPriorityDeliveryConfig(state),
    priorityDeliverySLPTagsConfig: getPriorityDeliverySLPTagsConfig(state),
  }
}
export default connect(mapStateToProps,null)(ProductCard);
